<template>
    <div class="inputBuscaUsuario">
        <b-input-group>
            <b-input-group-prepend>
                <b-button v-if="permitirLimpar" variant="secondary" @click="limpar">
                    <font-awesome-icon icon="times" />
                </b-button>
            </b-input-group-prepend>
            <b-form-input v-model="valorInput" autocomplete="off" debounce="400" @update="atualizouTexto"
                @input="inputTexto" data-1p-ignore :class="inputClass" />
            <b-input-group-append>
                <b-input-group-text :class="iconAreaClass" v-b-tooltip.hover :title="tooltipContent">
                    <font-awesome-icon :icon="iconeStatus" />
                </b-input-group-text>
            </b-input-group-append>
        </b-input-group>
        <div class="listWrapper">
            <b-list-group v-if="candidatos.length > 0" class="shadow-lg" v-click-outside-element="closeCands">
                <b-list-group-item v-for="cand in candidatos" :key="cand.IdUsuario" @click="clickOption(cand)" href="#"
                    class="text-truncate text-left p-2">
                    {{ cand.Cpf + ' - ' + cand.Nome }}
                </b-list-group-item>
            </b-list-group>
        </div>
    </div>
</template>
<script lang="ts">
import usuarioService from '@/services/administracao/usuarioService';
import { UsuarioSumario } from '@/types/usuario-sumario';
import { UtilsTS } from '@/utilsts';
import { PropType } from 'vue';
import { mixins } from 'vue-class-component';
import { Component, Vue, Watch } from 'vue-property-decorator';

const CompProps = Vue.extend({
    name: 'InputBuscaUsuarioUO',
    props: {
        value: {
            type: Object as PropType<UsuarioSumario>,
            required: false
        }
    }
})
@Component
export default class InputBuscaUsuarioUO extends mixins(UtilsTS, CompProps) {
    valorInput = ''
    status = 'empty' //empty, loading, typing, incomplete, complete
    candidatos: UsuarioSumario[] = []

    get iconeStatus() {
        switch (this.status) {
            case 'typing': return 'keyboard'
            case 'loading': return 'spinner'
            case 'complete': return 'user-tag'
            default: return 'question-circle'
        }
    }
    get inputClass() {
        switch (this.status) {
            case 'typing': return 'border-warning'
            case 'incomplete': return 'border-warning'
            case 'loading': return 'border-info'
            case 'complete': return 'border-success text-success'
            default: return ''
        }
    }
    get iconAreaClass() {
        switch (this.status) {
            case 'typing': return 'bg-warning'
            case 'incomplete': return 'bg-warning'
            case 'loading': return 'bg-info'
            case 'complete': return 'bg-success text-light'
            default: return ''
        }
    }
    get tooltipContent() {
        switch (this.status) {
            case 'incomplete': return 'usuário ainda não escolhido'
            case 'loading': return 'carregando lista de usuários'
            case 'complete': return 'usuário selecionado'
            default: return ''
        }
    }

    get permitirLimpar() {
        return this.status === 'incomplete' || this.status === 'complete'
    }

    async inputTexto(arg) {
        this.status = 'typing'
    }
    async atualizouTexto(arg) {
        try {
            this.status = 'incomplete'
            if (!arg || arg.trim().length < 4) {
                this.candidatos = []
                if (arg.trim().length === 0) this.status = 'empty'
                return
            }
            this.status = 'loading'
            this.candidatos = []

            const resp = await usuarioService.findByCpfNome(arg, true)
            //console.log(resp)
            if (resp.length > 0) this.candidatos = resp
        } catch (e: any) {
            console.error('falha ao buscar usuários', e)
        }
    }

    closeCands() {
        this.candidatos = []
        if (this.status === 'loading') this.status = 'incomplete'
    }
    clickOption(cand: UsuarioSumario) {
        this.valorInput = cand.Cpf + ' - ' + cand.Nome
        this.status = 'complete'
        this.candidatos = []
        this.$emit('input', cand)
    }

    limpar() {
        this.valorInput = ''
        this.status = 'empty'
        this.$emit('limpar')
    }

    @Watch('value')
    handleModelChange(newV) {
        if (!newV) this.limpar()
    }
    @Watch('status')
    handleStatusChange(newV, oldV) {
        if (newV !== 'complete' && newV !== oldV) this.$emit('input', null)
    }
}
</script>
<style scoped>
div.listWrapper {
    height: 0px;
}

div.listWrapper a {
    z-index: 10;
}
</style>